import { KitProductModel } from "../../Api/Models/product.model";
import { StockModel } from "../../Api/Models/stock.model";
import { t } from "i18next";
import {CheckIcon} from "../Icons/CheckIcon";
import React from "react";
import {ExchangeMissingIcon} from "../Icons/ExchangeMissingIcon";
import Popover from "../Popover";

interface ExchangeMissingProps {
  missingProducts: KitProductModel[];
  stocks: StockModel[];
  setMissingProducts: CallableFunction;
}

const ExchangeMissing: React.FunctionComponent<ExchangeMissingProps> = ({
  missingProducts,
  stocks,
  setMissingProducts,
}) => {
  const stockAvailable = (
    productId: number,
    variationId: number | null,
    quantity: number
  ): boolean => {
    let productStocks = stocks.filter((stock) => stock.productId === productId);

    if (variationId) {
      productStocks = productStocks.filter(
        (stock) => stock.variationId === variationId
      );
    }

    return productStocks.some((stock) => stock.quantity >= quantity);
  };

  return (
    <>
      {missingProducts
        .filter((x, index, array) => {
          if (!x.optionalGroupId) {
            return true;
          }

          if (
            array.some(
              (p) => p.optionalGroupId === x.optionalGroupId && p.selected
            )
          ) {
            return x.selected;
          }

          return (
            !x.optionalGroupId ||
            array.findIndex(
              (group) => group.optionalGroupId === x.optionalGroupId
            ) === index
          );
        })
        .map((kitProduct) => {
          if (
            kitProduct.optionalGroupId &&
            !missingProducts.some(
              (x) =>
                x.optionalGroupId === kitProduct.optionalGroupId && x.selected
            )
          ) {
            return (
                <div
                    className={`product-list-card mb-4 ${
                        kitProduct.checked ? "marked" : ""
                    }`}
                    key={kitProduct.id}
                >
                  <div className="relative">
                    <div className="flex items-center gap-2">

                      {/* Kép */}
                      <div className="relative">
                        <div className="product-list-card__image">
                          <img src={kitProduct.image || "https://via.placeholder.com/60"} alt="product"/>
                        </div>
                      </div>

                      <div className="w-full">
                        <div className="product-list-card__title">
                          <select
                              className={`input-field input-field--small input-field--auto-width ${!kitProduct.checked ? "text-gray" : "text-blue"}`}
                              onChange={(e) => {
                                setMissingProducts([
                                  ...missingProducts.map((item) => {
                                    if (item.optionalGroupId === kitProduct.optionalGroupId) {
                                      item.selected = false;
                                    }

                                    if (item.id === parseInt(e.target.value)) {
                                      item.selected = true;
                                      item.checked = true;
                                      if (item.variations.length > 0) {
                                        item.selectedVariationId =
                                            item.variations.find((x) =>
                                                stockAvailable(item.productId, x.id, item.quantity)
                                            )?.id ?? null;
                                      }
                                    }

                                    return item;
                                  }),
                                ]);
                              }}
                          >
                            <option>- Please Select -</option>
                            {missingProducts
                                .filter((x) => x.optionalGroupId === kitProduct.optionalGroupId)
                                .filter((x) =>
                                    stockAvailable(x.productId, null, x.quantity)
                                )
                                .map((groupProduct) => (
                                    <option key={groupProduct.id} value={groupProduct.id}>
                                      {groupProduct.name}
                                    </option>
                                ))}
                          </select>
                        </div>
                      </div>

                      <div className="flex gap-2 items-center">
                        {(!kitProduct.optionalGroupId || kitProduct.selected) && (
                            <button
                                type="button"
                                className={
                                  kitProduct.checked
                                      ? "product-list-card__check checked"
                                      : "product-list-card__check needtocheck"
                                }
                                onClick={() => {
                                  setMissingProducts([
                                    ...missingProducts.map((item) => {
                                      if (item.id === kitProduct.id) {
                                        item.checked = !item.checked;
                                      }
                                      return item;
                                    }),
                                  ]);
                                }}
                            >
                              {kitProduct.checked && <CheckIcon/>}
                            </button>
                        )}
                      
                        <div className="exchange-list-card__exchange-type-icon-holder">
                          <Popover defaultPosition={"left"} text={t('Missing product')}>
                            <div className="exchange-list-card__exchange-type-icon">
                              <ExchangeMissingIcon/>
                            </div>
                          </Popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            );
          }

          return (
              <div
                  className={`product-list-card mb-4 ${
                      kitProduct.checked ? "marked" : ""
                  }`}
                  key={kitProduct.id}
              >
                <div className="relative">
                  <div className="flex items-center gap-2">

                    <div className="relative">
                      <div className="product-list-card__image">
                        <img src={kitProduct.image || "https://via.placeholder.com/60"} alt="product"/>
                      </div>
                    </div>

                    <div className="w-full">
                      <div className="product-list-card__title">
                        {kitProduct.name}
                      </div>
                      {!stockAvailable(
                          kitProduct.productId,
                          null,
                          kitProduct.quantity
                      ) ? (
                          <span className="text-red">{t("Out of stock")}</span>
                      ) : (
                          <>
                            {kitProduct.optionalGroupId && (
                                <span
                                    className="text-blue"
                                    onClick={() => {
                                      setMissingProducts([
                                        ...missingProducts.map((item) => {
                                          if (item.optionalGroupId === kitProduct.optionalGroupId) {
                                            item.selected = false;
                                            item.checked = false;
                                          }
                                          return item;
                                        }),
                                      ]);
                                    }}
                                >
                {t("<< Select an other product")}
              </span>
                            )}
                          </>
                      )}

                  {
                    <div className="exchange-list-card__exchange-type-icon-holder">
                      <Popover defaultPosition={"left"} text={t('Missing Product')}>
                        <div className="exchange-list-card__exchange-type-icon">
                          <ExchangeMissingIcon/>
                        </div>
                      </Popover>
                    </div>
                  }

                    </div>

                    {stockAvailable(kitProduct.productId, null, kitProduct.quantity) && (
                        <div className="flex gap-2 items-center">
                          {kitProduct.variations.length > 0 && (
                              <select
                                  className="input-field input-field--small input-field--variation-width"
                                  value={kitProduct.selectedVariationId || -1}
                                  disabled={!stockAvailable(kitProduct.productId, null, kitProduct.quantity)}
                                  onChange={(e) => {
                                    const selectedVariationId = parseInt(e.target.value, 10);

                                    setMissingProducts((prev: KitProductModel[]) =>
                                        prev.map((item: KitProductModel) =>
                                            item.id === kitProduct.id
                                                ? {...item, selectedVariationId, checked: true}
                                                : item
                                        )
                                    );
                                  }}
                              >
                                <option value={-1} disabled>
                                  -
                                </option>
                                {kitProduct.variations
                                    .filter((x) =>
                                        stockAvailable(kitProduct.productId, x.id, kitProduct.quantity)
                                    )
                                    .map((x) => (
                                        <option value={x.id} key={x.id}>
                                          {x.name}
                                        </option>
                                    ))}
                              </select>


                          )}

                          <button
                              type="button"
                              className={kitProduct.checked ? "product-list-card__check checked" : "product-list-card__check needtocheck"}
                              onClick={() => {
                                setMissingProducts((prev: KitProductModel[]) =>
                                    prev.map((item: KitProductModel) =>
                                        item.id === kitProduct.id
                                            ? {
                                              ...item,
                                              checked: !item.checked,
                                              selectedVariationId: item.checked ? -1 : item.selectedVariationId,
                                            }
                                            : item
                                    )
                                );
                              }}
                          >
                            {kitProduct.checked && <CheckIcon/>}
                          </button>

                          <div className="exchange-list-card__exchange-type-icon-holder">
                            <Popover defaultPosition={"left"} text={t('Missing Product')}>
                              <div className="exchange-list-card__exchange-type-icon">
                                <ExchangeMissingIcon/>
                              </div>
                            </Popover>
                          </div>
                        </div>
                    )}
                  </div>
                </div>
              </div>
          );
        })}
    </>
  );
};

export default ExchangeMissing;
